import React, { useState, useRef, useEffect } from "react";
import { Tooltip } from "@mui/material";

const OverflowTooltip = ({ text }) => {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);
  const [containerWidth, setContainerWidth] = useState("auto");

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current && containerRef.current) {
        setContainerWidth(containerRef.current.clientWidth);
        setIsOverflow(
          textRef.current.scrollWidth > textRef.current.clientWidth
        );
      }
    };

    // Observar cambios en el tamaño del contenedor
    const resizeObserver = new ResizeObserver(() => checkOverflow());

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    checkOverflow(); // Revisar el tamaño inicial

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
      resizeObserver.disconnect();
    };
  }, [text]);

  return (
    <div ref={containerRef} style={{ flexGrow: 1, overflow: "hidden" }}>
      <Tooltip
        title={isOverflow ? text : ""}
        disableHoverListener={!isOverflow}
      >
        <div
          ref={textRef}
          style={{
            maxWidth: `${containerWidth}px`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            cursor: isOverflow ? "pointer" : "default",
          }}
        >
          {text}
        </div>
      </Tooltip>
    </div>
  );
};

export { OverflowTooltip };
